import { render } from "./simplepiechart.vue?vue&type=template&id=578da21e&scoped=true"
import script from "./simplepiechart.vue?vue&type=script&lang=js"
export * from "./simplepiechart.vue?vue&type=script&lang=js"

import "./simplepiechart.vue?vue&type=style&index=0&id=578da21e&scoped=true&lang=css"
import "./simplepiechart.vue?vue&type=style&index=1&id=578da21e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578da21e"]])

export default __exports__